import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';
import { PlotType } from '@/modules/ta/widget/widget.constants';
import { MapTypes, TapMapConfig } from '@/modules/ta/widget/builder.constants';

export class GeoChartDrawOption extends BaseDrawOption {
  /**
   * @type {string}
   */
  map_type;

  /**
   * @type {boolean}
   */
  has_tooltip;

  /**
   * @type {boolean}
   */
  map_geographic_features;

  /**
   * @type {boolean}
   */
  hide_zero_value;

  /**
   * @type {string}
   */
  tap_map_config;

  /**
   * @type {boolean}
   */
  tap_map_show_cluster_value;

  /**
   * @type {boolean}
   */
  tap_map_manually_adjust_dimensions;

  /**
   * @type {array}
   */
  layers;

  /**
   * @type {Number}
   */
  geo_limit;

  constructor(model = {}) {
    super(model);
    this.setValidPlotType(model);
    this.map_type = model.map_type ?? MapTypes.STREET;
    this.auto_zoom = model.auto_zoom ?? false;
    this.auto_zoom_threshold = model.auto_zoom_threshold ?? 90;
    this.has_tooltip = model.has_tooltip ?? false;
    this.map_geographic_features = model.map_geographic_features ?? false;
    this.hide_zero_value = model.hide_zero_value ?? false;
    this.geo_layer_opacity = model.geo_layer_opacity ?? 100;
    this.tap_map_config = model.tap_map_config ?? TapMapConfig.BOUNDARY;
    this.tap_map_show_cluster_value = model.tap_map_show_cluster_value ?? false;
    this.tap_map_manually_adjust_dimensions = model.tap_map_manually_adjust_dimensions ?? false;
    this.layers = model.layers ?? [];
    this.geo_limit = model.geo_limit ?? 1000;
  }

  setValidPlotType(model) {
    const validTypes = [
      PlotType.BUBBLE_MAP,
      PlotType.HEAT_MAP,
      PlotType.HEAT_MAP_V2,
      PlotType.BUBBLE_MAP_V2,
      PlotType.MAPBOX,
    ];

    if (!model.plot_type || !validTypes.includes(model.plot_type)) {
      this.plot_type = PlotType.BUBBLE_MAP_V2;
    } else {
      this.plot_type = model.plot_type;
    }
  }
}
